import { useAppDispatch } from 'app/hooks';
import useInterval from 'hooks/useInterval';
import { timeActions } from 'store/slices/timeSlice';
import { CHECK_TIME_INTERVAL } from '../constants';

const useUpdateTime = () => {
  const dispatch = useAppDispatch();

  const handleUpdateTime = () => {
    try {
      dispatch(timeActions.fetchTimeData());
    } catch (error) {
      console.error('useUpdateTime', error);
    }
  };

  useInterval(
    () => {
      handleUpdateTime();
    },
    CHECK_TIME_INTERVAL,
    true
  );
};

export default useUpdateTime;
